/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SharedserviceMelcoFusionModelsDefaultImage,
    SharedserviceMelcoFusionModelsDefaultImageFromJSON,
    SharedserviceMelcoFusionModelsDefaultImageFromJSONTyped,
    SharedserviceMelcoFusionModelsDefaultImageToJSON,
    SharedserviceMelcoModelsCanvasPreview,
    SharedserviceMelcoModelsCanvasPreviewFromJSON,
    SharedserviceMelcoModelsCanvasPreviewFromJSONTyped,
    SharedserviceMelcoModelsCanvasPreviewToJSON,
    SharedserviceMelcoModelsCustomWarning,
    SharedserviceMelcoModelsCustomWarningFromJSON,
    SharedserviceMelcoModelsCustomWarningFromJSONTyped,
    SharedserviceMelcoModelsCustomWarningToJSON,
    SharedserviceMelcoModelsUserImage,
    SharedserviceMelcoModelsUserImageFromJSON,
    SharedserviceMelcoModelsUserImageFromJSONTyped,
    SharedserviceMelcoModelsUserImageToJSON,
} from './';

/**
 * 
 * @export
 * @interface SharedserviceMelcoFusionModelsUserBlank
 */
export interface SharedserviceMelcoFusionModelsUserBlank {
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoFusionModelsUserBlank
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoFusionModelsUserBlank
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoFusionModelsUserBlank
     */
    canvas_width?: number;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoFusionModelsUserBlank
     */
    canvas_height?: number;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoFusionModelsUserBlank
     */
    views_count?: number;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoFusionModelsUserBlank
     */
    colors_count?: number;
    /**
     * 
     * @type {SharedserviceMelcoFusionModelsDefaultImage}
     * @memberof SharedserviceMelcoFusionModelsUserBlank
     */
    default_image?: SharedserviceMelcoFusionModelsDefaultImage;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoFusionModelsUserBlank
     */
    publish_state?: number;
    /**
     * 
     * @type {Date}
     * @memberof SharedserviceMelcoFusionModelsUserBlank
     */
    created_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SharedserviceMelcoFusionModelsUserBlank
     */
    publish_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof SharedserviceMelcoFusionModelsUserBlank
     */
    updated_date?: Date | null;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsUserImage>}
     * @memberof SharedserviceMelcoFusionModelsUserBlank
     */
    images?: Array<SharedserviceMelcoModelsUserImage> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SharedserviceMelcoFusionModelsUserBlank
     */
    colors?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SharedserviceMelcoFusionModelsUserBlank
     */
    views?: Array<string> | null;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsCanvasPreview>}
     * @memberof SharedserviceMelcoFusionModelsUserBlank
     */
    canvas_previews?: Array<SharedserviceMelcoModelsCanvasPreview> | null;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsCustomWarning>}
     * @memberof SharedserviceMelcoFusionModelsUserBlank
     */
    warning_list?: Array<SharedserviceMelcoModelsCustomWarning> | null;
}

export function SharedserviceMelcoFusionModelsUserBlankFromJSON(json: any): SharedserviceMelcoFusionModelsUserBlank {
    return SharedserviceMelcoFusionModelsUserBlankFromJSONTyped(json, false);
}

export function SharedserviceMelcoFusionModelsUserBlankFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedserviceMelcoFusionModelsUserBlank {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'canvas_width': !exists(json, 'canvas_width') ? undefined : json['canvas_width'],
        'canvas_height': !exists(json, 'canvas_height') ? undefined : json['canvas_height'],
        'views_count': !exists(json, 'views_count') ? undefined : json['views_count'],
        'colors_count': !exists(json, 'colors_count') ? undefined : json['colors_count'],
        'default_image': !exists(json, 'default_image') ? undefined : SharedserviceMelcoFusionModelsDefaultImageFromJSON(json['default_image']),
        'publish_state': !exists(json, 'publish_state') ? undefined : json['publish_state'],
        'created_date': !exists(json, 'created_date') ? undefined : (new Date(json['created_date'])),
        'publish_date': !exists(json, 'publish_date') ? undefined : (json['publish_date'] === null ? null : new Date(json['publish_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
        'images': !exists(json, 'images') ? undefined : (json['images'] === null ? null : (json['images'] as Array<any>).map(SharedserviceMelcoModelsUserImageFromJSON)),
        'colors': !exists(json, 'colors') ? undefined : json['colors'],
        'views': !exists(json, 'views') ? undefined : json['views'],
        'canvas_previews': !exists(json, 'canvas_previews') ? undefined : (json['canvas_previews'] === null ? null : (json['canvas_previews'] as Array<any>).map(SharedserviceMelcoModelsCanvasPreviewFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(SharedserviceMelcoModelsCustomWarningFromJSON)),
    };
}

export function SharedserviceMelcoFusionModelsUserBlankToJSON(value?: SharedserviceMelcoFusionModelsUserBlank | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'canvas_width': value.canvas_width,
        'canvas_height': value.canvas_height,
        'views_count': value.views_count,
        'colors_count': value.colors_count,
        'default_image': SharedserviceMelcoFusionModelsDefaultImageToJSON(value.default_image),
        'publish_state': value.publish_state,
        'created_date': value.created_date === undefined ? undefined : (value.created_date.toISOString()),
        'publish_date': value.publish_date === undefined ? undefined : (value.publish_date === null ? null : value.publish_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
        'images': value.images === undefined ? undefined : (value.images === null ? null : (value.images as Array<any>).map(SharedserviceMelcoModelsUserImageToJSON)),
        'colors': value.colors,
        'views': value.views,
        'canvas_previews': value.canvas_previews === undefined ? undefined : (value.canvas_previews === null ? null : (value.canvas_previews as Array<any>).map(SharedserviceMelcoModelsCanvasPreviewToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(SharedserviceMelcoModelsCustomWarningToJSON)),
    };
}


